import React from 'react';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormInstructions } from 'src/helpers/multilingualHelper';

const SectionBreakClientForm = ({ label, placeholder, config }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayInstructions = getFormInstructions(config?.instructions, currentLanguage);

    return (
        <div className="mb-6 w-full">
            <h2 className="text-lg text-gray-900">{displayLabel}</h2>
            <p className="mb-2 text-xs  text-gray-300">{displayInstructions}</p>
            <hr className="mt-2 border-gray-200" />
        </div>
    );
};

export default SectionBreakClientForm